import * as Sentry from "@sentry/react";
import { Config } from "@web/config/env";

export function initSentry() {
  if (!Config.SENTRY_DSN) return;

  Sentry.init({
    dsn: Config.SENTRY_DSN,
    environment: Config.ENV,
    initialScope: {
      tags: { app: "web" },
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: Config.ENV === "production" ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
